/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2024 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { FunctionComponent, VNode } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { classes, VComponent } from '@adobe-commerce/elsie/lib';
import '@/pdp/components/Header/Header.css';

export interface HeaderProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: VNode;
  sku: VNode;
  hideSku?: boolean;
}

export const Header: FunctionComponent<HeaderProps> = ({
  className,
  title,
  sku,
  hideSku = false,
  children,
  ...props
}) => {
  return (
    <div {...props} className={classes(['pdp-header', className])}>
      <div className="pdp-header__title">
        <VComponent node={title} />
      </div>
      {!hideSku && (
        <div className="pdp-header__sku">
          <VComponent node={sku} />
        </div>
      )}
    </div>
  );
};
